// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Users Page - Compact Design */
@keyframes usersPageFade {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

.users-page {
  padding: 0;
  max-width: 1400px;
  margin: 0 auto;
  min-height: calc(100vh - 80px);
  font-family: var(--font-body);
  background: transparent;
  /* только opacity — без translateY, меньше лишних слоёв при скролле */
  animation: usersPageFade 0.35s ease-out;
}

.users-content-surface {
  background: var(--bg-secondary);
  border: 1px solid var(--border-color);
  border-radius: 12px;
  box-shadow: var(--shadow-sm);
  padding: 24px;
  margin-bottom: 2rem;
}

/* Header */
.users-header {
  margin-bottom: 2.5rem;
  text-align: center;
}

.users-title {
  font-size: 3rem;
  font-weight: 700;
  color: var(--text-primary);
  margin: 0 0 0.5rem 0;
  letter-spacing: -0.02em;
  position: relative;
  display: inline-block;
}

.users-subtitle {
  font-size: 1.1rem;
  color: var(--text-secondary);
  font-weight: 400;
  margin: 0;
}

/* Filters */
.users-filters {
  background: var(--bg-secondary);
  border-radius: 16px;
  padding: 24px;
  margin-bottom: 2rem;
  box-shadow: var(--shadow-sm);
  border: 1px solid var(--border-color);
}

.filters-form {
  width: 100%;
}

.filter-row {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr auto;
  gap: 10px;
  align-items: end;
}

.filter-group {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.filter-label {
  font-size: 0.75rem;
  font-weight: 600;
  color: var(--text-secondary);
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.filter-input,
.filter-select {
  width: 100%;
  padding: 0.875rem 1.125rem;
  border: 1px solid var(--border-color);
  border-radius: 10px;
  font-size: 0.9375rem;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  background: var(--bg-primary);
  color: var(--text-primary);
}

.filter-input:focus,
.filter-select:focus {
  outline: none;
  border-color: var(--accent-color);
  background: var(--bg-secondary);
  box-shadow: 0 0 0 3px var(--nav-active-bg);
  transform: translateY(-2px);
}

.filter-input::placeholder {
  color: #94a3b8;
}

/* Search Panel Wrapper */
.search-panel-wrapper {
  position: relative;
  margin-bottom: 16px;
}

/* More Filters Menu */
.more-filters-wrapper {
  position: absolute;
  top: 1rem;
  right: 1rem;
  z-index: 10;
}

.more-filters-menu {
  position: relative;
  display: inline-block;
}

.more-filters-button {
  width: 40px;
  height: 40px;
  padding: 0;
  border: 1.5px solid var(--border-color);
  border-radius: 10px;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.2s ease, border-color 0.2s ease, color 0.2s ease;
  background: var(--bg-secondary);
  color: #475569;
  text-align: center;
  font-family: inherit;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.more-filters-button:hover {
  background: var(--nav-hover-bg);
  border-color: var(--border-color);
  color: #1e293b;
}

.more-filters-button.has-filters {
  border-color: var(--accent-primary);
  background: var(--nav-active-bg, var(--nav-hover-bg));
  color: var(--accent-primary);
}

.more-filters-icon {
  font-size: 1.25rem;
  line-height: 1;
  font-weight: 700;
  letter-spacing: 1px;
  transform: none;
}

.more-filters-badge {
  position: absolute;
  top: 4px;
  right: 4px;
  width: 8px;
  height: 8px;
  background: var(--accent-primary);
  border-radius: 50%;
  border: 2px solid white;
  box-shadow: none;
}

.more-filters-dropdown {
  position: absolute;
  top: calc(100% + 8px);
  right: 0;
  min-width: 280px;
  background: var(--bg-primary);
  border-radius: 12px;
  box-shadow: var(--shadow-md);
  border: 1px solid var(--border-color);
  z-index: 1000;
  overflow: visible;
  animation: none !important;
  transform: none !important;
}

.more-filters-header {
  padding: 1rem 1.25rem;
  border-bottom: 1px solid var(--border-color);
  background: var(--bg-primary);
}

.more-filters-title {
  font-size: 11px;
  font-weight: 700;
  color: #64748b;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.more-filters-content {
  padding: 1rem 1.25rem;
  display: flex;
  flex-direction: column;
  gap: 1.25rem;
}

.more-filters-item {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.more-filters-label {
  font-size: 0.8125rem;
  font-weight: 600;
  color: var(--text-secondary);
  margin-bottom: 0.25rem;
}

.more-filters-input {
  width: 100%;
  padding: 0.75rem 1rem;
  border: 2px solid var(--border-color);
  border-radius: 8px;
  font-size: 0.875rem;
  transition: all 0.3s ease;
  background: var(--bg-primary);
  color: var(--text-primary);
  font-family: inherit;
}

.more-filters-input:focus {
  outline: none;
  border-color: var(--accent-color);
  background: var(--bg-secondary);
  box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.10);
}

.more-filters-checkbox-label {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  cursor: pointer;
  padding: 0.5rem 0;
  -webkit-user-select: none;
          user-select: none;
}

.more-filters-checkbox {
  width: 20px;
  height: 20px;
  cursor: pointer;
  accent-color: var(--accent-primary);
  flex-shrink: 0;
}

.more-filters-checkbox-text {
  font-size: 0.9375rem;
  font-weight: 500;
  color: #1e293b;
  transition: color 0.3s ease;
}

.more-filters-checkbox-label:hover .more-filters-checkbox-text {
  color: var(--accent-primary);
}

@media (max-width: 768px) {
  .more-filters-wrapper {
    top: 0.75rem;
    right: 0.75rem;
  }

  .more-filters-button {
    width: 36px;
    height: 36px;
  }

  .more-filters-icon {
    font-size: 1.1rem;
  }

  .more-filters-dropdown {
    right: auto;
    left: 0;
    min-width: calc(100vw - 2rem);
    max-width: 320px;
  }
}

.filters-actions {
  display: flex;
  gap: 8px;
  align-items: center;
}

/* Unified Button Styles */
.btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 8px 14px;
  border: none;
  border-radius: 8px;
  font-size: 0.875rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  white-space: nowrap;
  font-family: inherit;
}

.btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.btn-primary {
  background: var(--accent-color);
  color: white;
  box-shadow: var(--shadow-sm);
}

.btn-primary:hover:not(:disabled) {
  transform: translateY(-1px);
  background: var(--accent-hover);
  box-shadow: var(--shadow-md);
}

.btn-secondary {
  background: var(--bg-primary);
  color: var(--text-primary);
  border: 1px solid var(--border-color);
  font-weight: 600;
}

.btn-secondary:hover:not(:disabled) {
  background: var(--nav-hover-bg);
  border-color: var(--accent-color);
  color: var(--text-primary);
}



/* Grid and Card base handled by cards.css */

.user-avatar {
  flex-shrink: 0;
}

.avatar-img {
  width: 44px;
  height: 44px;
  border-radius: 50%;
  object-fit: cover;
  border: 1px solid var(--border-color);
}

.avatar-placeholder {
  width: 44px;
  height: 44px;
  border-radius: 50%;
  background: var(--accent-color);
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 700;
  font-size: 1rem;
}

.user-main-info {
  flex: 1 1;
  min-width: 0;
}

.user-name-row {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;
  margin-bottom: 4px;
  min-width: 0;
  width: 100%;
}

.user-full-name {
  font-size: 1.02rem;
  font-weight: 700;
  color: var(--text-primary);
  line-height: 1.15;
  max-width: 100%;
  min-width: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.users-page .user-card-title {
  font-size: 1rem !important;
  margin-bottom: 2px !important;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  display: block;
}

.user-plan-tag {
  padding: 0 10px;
  border-radius: 8px;
  font-size: 0.7rem;
  font-weight: 600;
  line-height: 22px;
  text-transform: none;
  border: 1px solid transparent;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 22px;
}

.user-plan-tag.basic {
  background: rgba(148, 163, 184, 0.15);
  color: var(--text-secondary);
  border-color: rgba(148, 163, 184, 0.35);
}

.user-plan-tag.pro {
  background: rgba(245, 158, 11, 0.15);
  color: #c2410c;
  border-color: rgba(245, 158, 11, 0.35);
}

.user-plan-tag.premium {
  background: rgba(124, 58, 237, 0.15);
  color: #7e22ce;
  border-color: rgba(124, 58, 237, 0.35);
}

.user-meta {
  display: flex;
  flex-direction: column;
  gap: 0;
}

.user-company {
  font-size: 0.8rem;
  color: var(--text-secondary);
  font-weight: 600;
}

.user-rating-mini {
  display: flex;
  align-items: center;
  gap: 4px;
}

.rating-mini {
  display: flex;
  align-items: center;
  gap: 4px;
}

.mini-stars {
  display: flex;
  gap: 1px;
}

.star {
  font-size: 0.75rem;
  line-height: 1;
}

.star-full {
  color: var(--text-secondary);
}

.star-empty {
  color: var(--border-color);
}

.rating-value-mini {
  font-weight: 600;
  color: var(--text-primary);
  font-size: 0.8rem;
}

.users-page .user-card-phone-text {
  font-weight: 600;
}

.users-page .user-card-email-text.is-email {
  color: var(--accent-primary);
}

.users-page .user-card-title-row {
  display: block;
  width: 100%;
  max-width: 100%;
}

.users-page .user-card-title-row.has-verified {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  width: fit-content;
  min-width: 0;
}

.users-page .user-card-title-row.has-verified .user-card-title {
  flex: 0 1 auto;
  min-width: 0;
  max-width: calc(100% - 26px);
}

.users-page .user-verified-image {
  margin-left: 2px;
  width: 20px;
  height: 20px;
  display: inline-block;
  object-fit: contain;
  flex-shrink: 0;
}

.rating-count-mini {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0 5px;
  border-radius: 999px;
  background: var(--bg-tertiary);
  border: 1px solid var(--border-color);
  color: var(--text-secondary);
  font-size: 0.62rem;
  font-weight: 700;
  height: 14px;
  line-height: 14px;
  transform: none;
}

.rating-count-mini::before {
  content: '(';
  display: inline-block;
  transform: none;
  margin-right: 1px;
}

.rating-count-mini::after {
  content: ')';
  display: inline-block;
  transform: none;
  margin-left: 1px;
}

.role-mini {
  padding: 0 10px;
  border-radius: 8px;
  font-size: 0.7rem;
  font-weight: 600;
  white-space: nowrap;
  align-self: flex-start;
  border: 1px solid transparent;
  background: transparent;
  color: var(--text-secondary);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 22px;
  line-height: 21px;
}

.role-admin {
  background: rgba(239, 68, 68, 0.15);
  color: #ef4444;
  border-color: rgba(239, 68, 68, 0.35);
}

.role-moderator {
  background: rgba(124, 58, 237, 0.15);
  color: #a78bfa;
  border-color: rgba(124, 58, 237, 0.35);
}

.role-support {
  background: rgba(59, 130, 246, 0.15);
  color: #60a5fa;
  border-color: rgba(59, 130, 246, 0.35);
}

.role-provider {
  background: rgba(16, 185, 129, 0.15);
  color: #34d399;
  border-color: rgba(16, 185, 129, 0.35);
}

.role-customer {
  background: rgba(245, 158, 11, 0.15);
  color: #fbbf24;
  border-color: rgba(245, 158, 11, 0.35);
}

.role-default {
  background: var(--nav-hover-bg);
  color: var(--text-secondary);
  border-color: var(--border-color);
}

/* Details Grid */
.user-details-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 6px;
  margin-bottom: 10px;
  flex-grow: 1;
}

.detail-group {
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
  /* Allow grid items to shrink for ellipsis */
}


/* Details handled by cards.css */

/* Status Badge Colors */
.status-green {
  background: rgba(16, 185, 129, 0.15);
  color: #34d399;
}

.status-yellow {
  background: rgba(245, 158, 11, 0.15);
  color: #fbbf24;
}

.status-red {
  background: rgba(239, 68, 68, 0.15);
  color: #ef4444;
}

.status-gray {
  background: var(--nav-hover-bg);
  color: var(--text-secondary);
}

/* States */
.loading-state,
.empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 200px;
  color: var(--text-secondary);
  grid-column: 1 / -1;
  background: var(--bg-secondary);
  border-radius: 12px;
  border: 1px solid var(--border-color);
  padding: 2rem;
}


.empty-state-icon {
  font-size: 3rem;
  margin-bottom: 12px;
  opacity: 0.6;
}

.empty-state h3 {
  margin: 0 0 8px 0;
  font-size: 1.25rem;
  font-weight: 700;
  color: var(--text-primary);
}

.empty-state p {
  margin: 0;
  font-size: 0.875rem;
  color: var(--text-secondary);
}



/* Pagination handled by pagination.css */

/* Responsive */
@media (max-width: 1024px) {
  .filter-row {
    grid-template-columns: 1fr 1fr auto;
  }
}

@media (max-width: 768px) {
  .users-page {
    padding: 0;
    margin-top: 0;
  }

  .users-content-surface {
    padding: 16px;
  }

  .filter-row {
    grid-template-columns: 1fr;
    gap: 8px;
  }

  .filters-actions {
    justify-content: stretch;
  }

  .btn {
    flex: 1 1;
  }

  .users-grid {
    grid-template-columns: 1fr;
    gap: 10px;
  }

  .user-details-grid {
    grid-template-columns: 1fr;
  }

  .pagination {
    gap: 4px;
  }

  .pagination-btn {
    min-width: 36px;
    height: 36px;
    padding: 6px 10px;
    font-size: 0.8rem;
  }

  .pagination-btn-nav {
    padding: 6px 12px;
    font-size: 0.8rem;
  }

  .pagination-info {
    font-size: 0.8rem;
    text-align: center;
  }
}

@media (max-width: 480px) {
  .pagination-numbers {
    gap: 2px;
  }

  .pagination-btn {
    min-width: 32px;
    height: 32px;
    padding: 4px 8px;
    font-size: 0.75rem;
  }

  .pagination-btn-nav {
    padding: 4px 8px;
    font-size: 0.75rem;
  }

  .pagination-ellipsis {
    min-width: 32px;
    height: 32px;
  }
}

/* Фильтр пользователей по категориям провайдера */
.more-filters-categories-block {
  grid-column: 1 / -1;
  margin-top: 8px;
  padding-top: 12px;
  border-top: 1px dashed rgba(148, 163, 184, 0.45);
}

.more-filters-categories-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  flex-wrap: wrap;
}

.more-filters-categories-hint {
  margin: 4px 0 10px;
  font-size: 0.78rem;
  color: var(--text-secondary, #64748b);
  line-height: 1.35;
}

.more-filters-categories-clear {
  border: none;
  background: transparent;
  color: var(--accent-primary, #6366f1);
  font-size: 0.78rem;
  font-weight: 600;
  cursor: pointer;
  padding: 4px 0;
  text-decoration: underline;
  text-underline-offset: 2px;
}

.more-filters-categories-clear:hover {
  opacity: 0.85;
}

.more-filters-categories-search {
  margin-bottom: 10px;
}

.more-filters-categories-status {
  font-size: 0.85rem;
  color: var(--text-secondary, #64748b);
  padding: 8px 0;
}

.more-filters-categories-error {
  color: #dc2626;
}

.more-filters-category-chips {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  margin-bottom: 10px;
}

.more-filters-category-chip {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  max-width: 100%;
  padding: 4px 8px 4px 10px;
  border-radius: 999px;
  border: 1px solid var(--border-accent, #c7d2fe);
  background: var(--chip-bg, #eef2ff);
  color: var(--chip-text, #3730a3);
  font-size: 0.78rem;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.15s ease, border-color 0.15s ease;
}

.more-filters-category-chip:hover {
  opacity: 0.92;
}

.more-filters-category-chip-label {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 200px;
}

.more-filters-category-chip-x {
  font-size: 1rem;
  line-height: 1;
  opacity: 0.7;
}

.more-filters-categories-list {
  max-height: 240px;
  overflow-y: auto;
  border: 1px solid var(--border-color, #e2e8f0);
  border-radius: 10px;
  background: var(--bg-secondary, #fafafa);
}

.more-filters-category-row {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  padding: 8px 12px;
  cursor: pointer;
  font-size: 0.85rem;
  border-bottom: 1px solid var(--border-subtle, #f1f5f9);
  margin: 0;
}

.more-filters-category-row:last-child {
  border-bottom: none;
}

.more-filters-category-row:hover {
  background: var(--bg-primary, #fff);
}

.more-filters-category-row input {
  margin-top: 3px;
  flex-shrink: 0;
  accent-color: var(--accent-primary, #6366f1);
}

.more-filters-category-title {
  flex: 1 1;
  min-width: 0;
  line-height: 1.35;
  word-break: break-word;
}
/* Тёмная тема (DEV): текст кнопки/чекбоксов доп.фильтров сливался,
   белая обводка бейджа — под тёмную поверхность. */
:root[data-theme='dark'] .more-filters-button {
  color: var(--text-secondary);
}

:root[data-theme='dark'] .more-filters-button:hover,
:root[data-theme='dark'] .more-filters-checkbox-text {
  color: var(--text-primary);
}

:root[data-theme='dark'] .more-filters-badge {
  border-color: var(--bg-card);
}
`, "",{"version":3,"sources":["webpack://./src/css/users.css"],"names":[],"mappings":"AAAA,gCAAgC;AAChC;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;;AAEA;EACE,UAAU;EACV,iBAAiB;EACjB,cAAc;EACd,8BAA8B;EAC9B,6BAA6B;EAC7B,uBAAuB;EACvB,qEAAqE;EACrE,uCAAuC;AACzC;;AAEA;EACE,+BAA+B;EAC/B,qCAAqC;EACrC,mBAAmB;EACnB,4BAA4B;EAC5B,aAAa;EACb,mBAAmB;AACrB;;AAEA,WAAW;AACX;EACE,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,oBAAoB;EACpB,uBAAuB;EACvB,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,4BAA4B;EAC5B,gBAAgB;EAChB,SAAS;AACX;;AAEA,YAAY;AACZ;EACE,+BAA+B;EAC/B,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,4BAA4B;EAC5B,qCAAqC;AACvC;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,uCAAuC;EACvC,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,4BAA4B;EAC5B,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;EAEE,WAAW;EACX,0BAA0B;EAC1B,qCAAqC;EACrC,mBAAmB;EACnB,oBAAoB;EACpB,iDAAiD;EACjD,6BAA6B;EAC7B,0BAA0B;AAC5B;;AAEA;;EAEE,aAAa;EACb,iCAAiC;EACjC,+BAA+B;EAC/B,0CAA0C;EAC1C,2BAA2B;AAC7B;;AAEA;EACE,cAAc;AAChB;;AAEA,yBAAyB;AACzB;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA,sBAAsB;AACtB;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,UAAU;EACV,uCAAuC;EACvC,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yEAAyE;EACzE,+BAA+B;EAC/B,cAAc;EACd,kBAAkB;EAClB,oBAAoB;EACpB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,+BAA+B;EAC/B,iCAAiC;EACjC,cAAc;AAChB;;AAEA;EACE,mCAAmC;EACnC,qDAAqD;EACrD,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,UAAU;EACV,WAAW;EACX,iCAAiC;EACjC,kBAAkB;EAClB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,QAAQ;EACR,gBAAgB;EAChB,6BAA6B;EAC7B,mBAAmB;EACnB,4BAA4B;EAC5B,qCAAqC;EACrC,aAAa;EACb,iBAAiB;EACjB,0BAA0B;EAC1B,0BAA0B;AAC5B;;AAEA;EACE,qBAAqB;EACrB,4CAA4C;EAC5C,6BAA6B;AAC/B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,4BAA4B;EAC5B,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,qBAAqB;EACrB,qCAAqC;EACrC,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,6BAA6B;EAC7B,0BAA0B;EAC1B,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,iCAAiC;EACjC,+BAA+B;EAC/B,6CAA6C;AAC/C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,mCAAmC;EACnC,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,cAAc;EACd,2BAA2B;AAC7B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE;IACE,YAAY;IACZ,cAAc;EAChB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,WAAW;IACX,OAAO;IACP,6BAA6B;IAC7B,gBAAgB;EAClB;AACF;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;AACrB;;AAEA,0BAA0B;AAC1B;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,+BAA+B;EAC/B,YAAY;EACZ,4BAA4B;AAC9B;;AAEA;EACE,2BAA2B;EAC3B,+BAA+B;EAC/B,4BAA4B;AAC9B;;AAEA;EACE,6BAA6B;EAC7B,0BAA0B;EAC1B,qCAAqC;EACrC,gBAAgB;AAClB;;AAEA;EACE,+BAA+B;EAC/B,iCAAiC;EACjC,0BAA0B;AAC5B;;;;AAIA,4CAA4C;;AAE5C;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,qCAAqC;AACvC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,+BAA+B;EAC/B,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,SAAO;EACP,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,QAAQ;EACR,kBAAkB;EAClB,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,0BAA0B;EAC1B,iBAAiB;EACjB,eAAe;EACf,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,0BAA0B;EAC1B,6BAA6B;EAC7B,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;EACjB,oBAAoB;EACpB,6BAA6B;EAC7B,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,qCAAqC;EACrC,4BAA4B;EAC5B,uCAAuC;AACzC;;AAEA;EACE,oCAAoC;EACpC,cAAc;EACd,sCAAsC;AACxC;;AAEA;EACE,oCAAoC;EACpC,cAAc;EACd,sCAAsC;AACxC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,MAAM;AACR;;AAEA;EACE,iBAAiB;EACjB,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;EAChB,0BAA0B;EAC1B,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,cAAc;EACd,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,4BAA4B;AAC9B;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,oBAAoB;EACpB,8BAA8B;EAC9B,qCAAqC;EACrC,4BAA4B;EAC5B,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,qBAAqB;EACrB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,qBAAqB;EACrB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,sBAAsB;EACtB,6BAA6B;EAC7B,uBAAuB;EACvB,4BAA4B;EAC5B,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,mCAAmC;EACnC,cAAc;EACd,qCAAqC;AACvC;;AAEA;EACE,oCAAoC;EACpC,cAAc;EACd,sCAAsC;AACxC;;AAEA;EACE,oCAAoC;EACpC,cAAc;EACd,sCAAsC;AACxC;;AAEA;EACE,oCAAoC;EACpC,cAAc;EACd,sCAAsC;AACxC;;AAEA;EACE,oCAAoC;EACpC,cAAc;EACd,sCAAsC;AACxC;;AAEA;EACE,+BAA+B;EAC/B,4BAA4B;EAC5B,iCAAiC;AACnC;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,8BAA8B;EAC9B,QAAQ;EACR,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;EACZ,4CAA4C;AAC9C;;;AAGA,iCAAiC;;AAEjC,wBAAwB;AACxB;EACE,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,mCAAmC;EACnC,cAAc;AAChB;;AAEA;EACE,+BAA+B;EAC/B,4BAA4B;AAC9B;;AAEA,WAAW;AACX;;EAEE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,4BAA4B;EAC5B,mBAAmB;EACnB,+BAA+B;EAC/B,mBAAmB;EACnB,qCAAqC;EACrC,aAAa;AACf;;;AAGA;EACE,eAAe;EACf,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,SAAS;EACT,mBAAmB;EACnB,4BAA4B;AAC9B;;;;AAIA,yCAAyC;;AAEzC,eAAe;AACf;EACE;IACE,mCAAmC;EACrC;AACF;;AAEA;EACE;IACE,UAAU;IACV,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,0BAA0B;IAC1B,QAAQ;EACV;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,SAAO;EACT;;EAEA;IACE,0BAA0B;IAC1B,SAAS;EACX;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,eAAe;IACf,YAAY;IACZ,iBAAiB;IACjB,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;IACjB,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,QAAQ;EACV;;EAEA;IACE,eAAe;IACf,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;IACE,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,YAAY;EACd;AACF;;AAEA,kDAAkD;AAClD;EACE,mBAAmB;EACnB,eAAe;EACf,iBAAiB;EACjB,gDAAgD;AAClD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,qCAAqC;EACrC,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,uBAAuB;EACvB,qCAAqC;EACrC,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,0BAA0B;EAC1B,0BAA0B;AAC5B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,qCAAqC;EACrC,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,yBAAyB;EACzB,oBAAoB;EACpB,+CAA+C;EAC/C,mCAAmC;EACnC,gCAAgC;EAChC,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,0DAA0D;AAC5D;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,8CAA8C;EAC9C,mBAAmB;EACnB,wCAAwC;AAC1C;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,iBAAiB;EACjB,eAAe;EACf,kBAAkB;EAClB,sDAAsD;EACtD,SAAS;AACX;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,eAAe;EACf,cAAc;EACd,4CAA4C;AAC9C;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,iBAAiB;EACjB,sBAAsB;AACxB;AACA;mDACmD;AACnD;EACE,4BAA4B;AAC9B;;AAEA;;EAEE,0BAA0B;AAC5B;;AAEA;EACE,4BAA4B;AAC9B","sourcesContent":["/* Users Page - Compact Design */\n@keyframes usersPageFade {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n\n.users-page {\n  padding: 0;\n  max-width: 1400px;\n  margin: 0 auto;\n  min-height: calc(100vh - 80px);\n  font-family: var(--font-body);\n  background: transparent;\n  /* только opacity — без translateY, меньше лишних слоёв при скролле */\n  animation: usersPageFade 0.35s ease-out;\n}\n\n.users-content-surface {\n  background: var(--bg-secondary);\n  border: 1px solid var(--border-color);\n  border-radius: 12px;\n  box-shadow: var(--shadow-sm);\n  padding: 24px;\n  margin-bottom: 2rem;\n}\n\n/* Header */\n.users-header {\n  margin-bottom: 2.5rem;\n  text-align: center;\n}\n\n.users-title {\n  font-size: 3rem;\n  font-weight: 700;\n  color: var(--text-primary);\n  margin: 0 0 0.5rem 0;\n  letter-spacing: -0.02em;\n  position: relative;\n  display: inline-block;\n}\n\n.users-subtitle {\n  font-size: 1.1rem;\n  color: var(--text-secondary);\n  font-weight: 400;\n  margin: 0;\n}\n\n/* Filters */\n.users-filters {\n  background: var(--bg-secondary);\n  border-radius: 16px;\n  padding: 24px;\n  margin-bottom: 2rem;\n  box-shadow: var(--shadow-sm);\n  border: 1px solid var(--border-color);\n}\n\n.filters-form {\n  width: 100%;\n}\n\n.filter-row {\n  display: grid;\n  grid-template-columns: 1fr 1fr 1fr auto;\n  gap: 10px;\n  align-items: end;\n}\n\n.filter-group {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.filter-label {\n  font-size: 0.75rem;\n  font-weight: 600;\n  color: var(--text-secondary);\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.filter-input,\n.filter-select {\n  width: 100%;\n  padding: 0.875rem 1.125rem;\n  border: 1px solid var(--border-color);\n  border-radius: 10px;\n  font-size: 0.9375rem;\n  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n  background: var(--bg-primary);\n  color: var(--text-primary);\n}\n\n.filter-input:focus,\n.filter-select:focus {\n  outline: none;\n  border-color: var(--accent-color);\n  background: var(--bg-secondary);\n  box-shadow: 0 0 0 3px var(--nav-active-bg);\n  transform: translateY(-2px);\n}\n\n.filter-input::placeholder {\n  color: #94a3b8;\n}\n\n/* Search Panel Wrapper */\n.search-panel-wrapper {\n  position: relative;\n  margin-bottom: 16px;\n}\n\n/* More Filters Menu */\n.more-filters-wrapper {\n  position: absolute;\n  top: 1rem;\n  right: 1rem;\n  z-index: 10;\n}\n\n.more-filters-menu {\n  position: relative;\n  display: inline-block;\n}\n\n.more-filters-button {\n  width: 40px;\n  height: 40px;\n  padding: 0;\n  border: 1.5px solid var(--border-color);\n  border-radius: 10px;\n  font-size: 1rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: background 0.2s ease, border-color 0.2s ease, color 0.2s ease;\n  background: var(--bg-secondary);\n  color: #475569;\n  text-align: center;\n  font-family: inherit;\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n}\n\n.more-filters-button:hover {\n  background: var(--nav-hover-bg);\n  border-color: var(--border-color);\n  color: #1e293b;\n}\n\n.more-filters-button.has-filters {\n  border-color: var(--accent-primary);\n  background: var(--nav-active-bg, var(--nav-hover-bg));\n  color: var(--accent-primary);\n}\n\n.more-filters-icon {\n  font-size: 1.25rem;\n  line-height: 1;\n  font-weight: 700;\n  letter-spacing: 1px;\n  transform: none;\n}\n\n.more-filters-badge {\n  position: absolute;\n  top: 4px;\n  right: 4px;\n  width: 8px;\n  height: 8px;\n  background: var(--accent-primary);\n  border-radius: 50%;\n  border: 2px solid white;\n  box-shadow: none;\n}\n\n.more-filters-dropdown {\n  position: absolute;\n  top: calc(100% + 8px);\n  right: 0;\n  min-width: 280px;\n  background: var(--bg-primary);\n  border-radius: 12px;\n  box-shadow: var(--shadow-md);\n  border: 1px solid var(--border-color);\n  z-index: 1000;\n  overflow: visible;\n  animation: none !important;\n  transform: none !important;\n}\n\n.more-filters-header {\n  padding: 1rem 1.25rem;\n  border-bottom: 1px solid var(--border-color);\n  background: var(--bg-primary);\n}\n\n.more-filters-title {\n  font-size: 11px;\n  font-weight: 700;\n  color: #64748b;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.more-filters-content {\n  padding: 1rem 1.25rem;\n  display: flex;\n  flex-direction: column;\n  gap: 1.25rem;\n}\n\n.more-filters-item {\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n}\n\n.more-filters-label {\n  font-size: 0.8125rem;\n  font-weight: 600;\n  color: var(--text-secondary);\n  margin-bottom: 0.25rem;\n}\n\n.more-filters-input {\n  width: 100%;\n  padding: 0.75rem 1rem;\n  border: 2px solid var(--border-color);\n  border-radius: 8px;\n  font-size: 0.875rem;\n  transition: all 0.3s ease;\n  background: var(--bg-primary);\n  color: var(--text-primary);\n  font-family: inherit;\n}\n\n.more-filters-input:focus {\n  outline: none;\n  border-color: var(--accent-color);\n  background: var(--bg-secondary);\n  box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.10);\n}\n\n.more-filters-checkbox-label {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n  cursor: pointer;\n  padding: 0.5rem 0;\n  user-select: none;\n}\n\n.more-filters-checkbox {\n  width: 20px;\n  height: 20px;\n  cursor: pointer;\n  accent-color: var(--accent-primary);\n  flex-shrink: 0;\n}\n\n.more-filters-checkbox-text {\n  font-size: 0.9375rem;\n  font-weight: 500;\n  color: #1e293b;\n  transition: color 0.3s ease;\n}\n\n.more-filters-checkbox-label:hover .more-filters-checkbox-text {\n  color: var(--accent-primary);\n}\n\n@media (max-width: 768px) {\n  .more-filters-wrapper {\n    top: 0.75rem;\n    right: 0.75rem;\n  }\n\n  .more-filters-button {\n    width: 36px;\n    height: 36px;\n  }\n\n  .more-filters-icon {\n    font-size: 1.1rem;\n  }\n\n  .more-filters-dropdown {\n    right: auto;\n    left: 0;\n    min-width: calc(100vw - 2rem);\n    max-width: 320px;\n  }\n}\n\n.filters-actions {\n  display: flex;\n  gap: 8px;\n  align-items: center;\n}\n\n/* Unified Button Styles */\n.btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  padding: 8px 14px;\n  border: none;\n  border-radius: 8px;\n  font-size: 0.875rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  white-space: nowrap;\n  font-family: inherit;\n}\n\n.btn:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.btn-primary {\n  background: var(--accent-color);\n  color: white;\n  box-shadow: var(--shadow-sm);\n}\n\n.btn-primary:hover:not(:disabled) {\n  transform: translateY(-1px);\n  background: var(--accent-hover);\n  box-shadow: var(--shadow-md);\n}\n\n.btn-secondary {\n  background: var(--bg-primary);\n  color: var(--text-primary);\n  border: 1px solid var(--border-color);\n  font-weight: 600;\n}\n\n.btn-secondary:hover:not(:disabled) {\n  background: var(--nav-hover-bg);\n  border-color: var(--accent-color);\n  color: var(--text-primary);\n}\n\n\n\n/* Grid and Card base handled by cards.css */\n\n.user-avatar {\n  flex-shrink: 0;\n}\n\n.avatar-img {\n  width: 44px;\n  height: 44px;\n  border-radius: 50%;\n  object-fit: cover;\n  border: 1px solid var(--border-color);\n}\n\n.avatar-placeholder {\n  width: 44px;\n  height: 44px;\n  border-radius: 50%;\n  background: var(--accent-color);\n  color: white;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-weight: 700;\n  font-size: 1rem;\n}\n\n.user-main-info {\n  flex: 1;\n  min-width: 0;\n}\n\n.user-name-row {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 4px;\n  margin-bottom: 4px;\n  min-width: 0;\n  width: 100%;\n}\n\n.user-full-name {\n  font-size: 1.02rem;\n  font-weight: 700;\n  color: var(--text-primary);\n  line-height: 1.15;\n  max-width: 100%;\n  min-width: 0;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.users-page .user-card-title {\n  font-size: 1rem !important;\n  margin-bottom: 2px !important;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  display: block;\n}\n\n.user-plan-tag {\n  padding: 0 10px;\n  border-radius: 8px;\n  font-size: 0.7rem;\n  font-weight: 600;\n  line-height: 22px;\n  text-transform: none;\n  border: 1px solid transparent;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  height: 22px;\n}\n\n.user-plan-tag.basic {\n  background: rgba(148, 163, 184, 0.15);\n  color: var(--text-secondary);\n  border-color: rgba(148, 163, 184, 0.35);\n}\n\n.user-plan-tag.pro {\n  background: rgba(245, 158, 11, 0.15);\n  color: #c2410c;\n  border-color: rgba(245, 158, 11, 0.35);\n}\n\n.user-plan-tag.premium {\n  background: rgba(124, 58, 237, 0.15);\n  color: #7e22ce;\n  border-color: rgba(124, 58, 237, 0.35);\n}\n\n.user-meta {\n  display: flex;\n  flex-direction: column;\n  gap: 0;\n}\n\n.user-company {\n  font-size: 0.8rem;\n  color: var(--text-secondary);\n  font-weight: 600;\n}\n\n.user-rating-mini {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n}\n\n.rating-mini {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n}\n\n.mini-stars {\n  display: flex;\n  gap: 1px;\n}\n\n.star {\n  font-size: 0.75rem;\n  line-height: 1;\n}\n\n.star-full {\n  color: var(--text-secondary);\n}\n\n.star-empty {\n  color: var(--border-color);\n}\n\n.rating-value-mini {\n  font-weight: 600;\n  color: var(--text-primary);\n  font-size: 0.8rem;\n}\n\n.users-page .user-card-phone-text {\n  font-weight: 600;\n}\n\n.users-page .user-card-email-text.is-email {\n  color: var(--accent-primary);\n}\n\n.users-page .user-card-title-row {\n  display: block;\n  width: 100%;\n  max-width: 100%;\n}\n\n.users-page .user-card-title-row.has-verified {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  width: fit-content;\n  min-width: 0;\n}\n\n.users-page .user-card-title-row.has-verified .user-card-title {\n  flex: 0 1 auto;\n  min-width: 0;\n  max-width: calc(100% - 26px);\n}\n\n.users-page .user-verified-image {\n  margin-left: 2px;\n  width: 20px;\n  height: 20px;\n  display: inline-block;\n  object-fit: contain;\n  flex-shrink: 0;\n}\n\n.rating-count-mini {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  padding: 0 5px;\n  border-radius: 999px;\n  background: var(--bg-tertiary);\n  border: 1px solid var(--border-color);\n  color: var(--text-secondary);\n  font-size: 0.62rem;\n  font-weight: 700;\n  height: 14px;\n  line-height: 14px;\n  transform: none;\n}\n\n.rating-count-mini::before {\n  content: '(';\n  display: inline-block;\n  transform: none;\n  margin-right: 1px;\n}\n\n.rating-count-mini::after {\n  content: ')';\n  display: inline-block;\n  transform: none;\n  margin-left: 1px;\n}\n\n.role-mini {\n  padding: 0 10px;\n  border-radius: 8px;\n  font-size: 0.7rem;\n  font-weight: 600;\n  white-space: nowrap;\n  align-self: flex-start;\n  border: 1px solid transparent;\n  background: transparent;\n  color: var(--text-secondary);\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  height: 22px;\n  line-height: 21px;\n}\n\n.role-admin {\n  background: rgba(239, 68, 68, 0.15);\n  color: #ef4444;\n  border-color: rgba(239, 68, 68, 0.35);\n}\n\n.role-moderator {\n  background: rgba(124, 58, 237, 0.15);\n  color: #a78bfa;\n  border-color: rgba(124, 58, 237, 0.35);\n}\n\n.role-support {\n  background: rgba(59, 130, 246, 0.15);\n  color: #60a5fa;\n  border-color: rgba(59, 130, 246, 0.35);\n}\n\n.role-provider {\n  background: rgba(16, 185, 129, 0.15);\n  color: #34d399;\n  border-color: rgba(16, 185, 129, 0.35);\n}\n\n.role-customer {\n  background: rgba(245, 158, 11, 0.15);\n  color: #fbbf24;\n  border-color: rgba(245, 158, 11, 0.35);\n}\n\n.role-default {\n  background: var(--nav-hover-bg);\n  color: var(--text-secondary);\n  border-color: var(--border-color);\n}\n\n/* Details Grid */\n.user-details-grid {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 6px;\n  margin-bottom: 10px;\n  flex-grow: 1;\n}\n\n.detail-group {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  min-width: 0;\n  /* Allow grid items to shrink for ellipsis */\n}\n\n\n/* Details handled by cards.css */\n\n/* Status Badge Colors */\n.status-green {\n  background: rgba(16, 185, 129, 0.15);\n  color: #34d399;\n}\n\n.status-yellow {\n  background: rgba(245, 158, 11, 0.15);\n  color: #fbbf24;\n}\n\n.status-red {\n  background: rgba(239, 68, 68, 0.15);\n  color: #ef4444;\n}\n\n.status-gray {\n  background: var(--nav-hover-bg);\n  color: var(--text-secondary);\n}\n\n/* States */\n.loading-state,\n.empty-state {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  min-height: 200px;\n  color: var(--text-secondary);\n  grid-column: 1 / -1;\n  background: var(--bg-secondary);\n  border-radius: 12px;\n  border: 1px solid var(--border-color);\n  padding: 2rem;\n}\n\n\n.empty-state-icon {\n  font-size: 3rem;\n  margin-bottom: 12px;\n  opacity: 0.6;\n}\n\n.empty-state h3 {\n  margin: 0 0 8px 0;\n  font-size: 1.25rem;\n  font-weight: 700;\n  color: var(--text-primary);\n}\n\n.empty-state p {\n  margin: 0;\n  font-size: 0.875rem;\n  color: var(--text-secondary);\n}\n\n\n\n/* Pagination handled by pagination.css */\n\n/* Responsive */\n@media (max-width: 1024px) {\n  .filter-row {\n    grid-template-columns: 1fr 1fr auto;\n  }\n}\n\n@media (max-width: 768px) {\n  .users-page {\n    padding: 0;\n    margin-top: 0;\n  }\n\n  .users-content-surface {\n    padding: 16px;\n  }\n\n  .filter-row {\n    grid-template-columns: 1fr;\n    gap: 8px;\n  }\n\n  .filters-actions {\n    justify-content: stretch;\n  }\n\n  .btn {\n    flex: 1;\n  }\n\n  .users-grid {\n    grid-template-columns: 1fr;\n    gap: 10px;\n  }\n\n  .user-details-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .pagination {\n    gap: 4px;\n  }\n\n  .pagination-btn {\n    min-width: 36px;\n    height: 36px;\n    padding: 6px 10px;\n    font-size: 0.8rem;\n  }\n\n  .pagination-btn-nav {\n    padding: 6px 12px;\n    font-size: 0.8rem;\n  }\n\n  .pagination-info {\n    font-size: 0.8rem;\n    text-align: center;\n  }\n}\n\n@media (max-width: 480px) {\n  .pagination-numbers {\n    gap: 2px;\n  }\n\n  .pagination-btn {\n    min-width: 32px;\n    height: 32px;\n    padding: 4px 8px;\n    font-size: 0.75rem;\n  }\n\n  .pagination-btn-nav {\n    padding: 4px 8px;\n    font-size: 0.75rem;\n  }\n\n  .pagination-ellipsis {\n    min-width: 32px;\n    height: 32px;\n  }\n}\n\n/* Фильтр пользователей по категориям провайдера */\n.more-filters-categories-block {\n  grid-column: 1 / -1;\n  margin-top: 8px;\n  padding-top: 12px;\n  border-top: 1px dashed rgba(148, 163, 184, 0.45);\n}\n\n.more-filters-categories-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n  flex-wrap: wrap;\n}\n\n.more-filters-categories-hint {\n  margin: 4px 0 10px;\n  font-size: 0.78rem;\n  color: var(--text-secondary, #64748b);\n  line-height: 1.35;\n}\n\n.more-filters-categories-clear {\n  border: none;\n  background: transparent;\n  color: var(--accent-primary, #6366f1);\n  font-size: 0.78rem;\n  font-weight: 600;\n  cursor: pointer;\n  padding: 4px 0;\n  text-decoration: underline;\n  text-underline-offset: 2px;\n}\n\n.more-filters-categories-clear:hover {\n  opacity: 0.85;\n}\n\n.more-filters-categories-search {\n  margin-bottom: 10px;\n}\n\n.more-filters-categories-status {\n  font-size: 0.85rem;\n  color: var(--text-secondary, #64748b);\n  padding: 8px 0;\n}\n\n.more-filters-categories-error {\n  color: #dc2626;\n}\n\n.more-filters-category-chips {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 6px;\n  margin-bottom: 10px;\n}\n\n.more-filters-category-chip {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  max-width: 100%;\n  padding: 4px 8px 4px 10px;\n  border-radius: 999px;\n  border: 1px solid var(--border-accent, #c7d2fe);\n  background: var(--chip-bg, #eef2ff);\n  color: var(--chip-text, #3730a3);\n  font-size: 0.78rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: background 0.15s ease, border-color 0.15s ease;\n}\n\n.more-filters-category-chip:hover {\n  opacity: 0.92;\n}\n\n.more-filters-category-chip-label {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  max-width: 200px;\n}\n\n.more-filters-category-chip-x {\n  font-size: 1rem;\n  line-height: 1;\n  opacity: 0.7;\n}\n\n.more-filters-categories-list {\n  max-height: 240px;\n  overflow-y: auto;\n  border: 1px solid var(--border-color, #e2e8f0);\n  border-radius: 10px;\n  background: var(--bg-secondary, #fafafa);\n}\n\n.more-filters-category-row {\n  display: flex;\n  align-items: flex-start;\n  gap: 10px;\n  padding: 8px 12px;\n  cursor: pointer;\n  font-size: 0.85rem;\n  border-bottom: 1px solid var(--border-subtle, #f1f5f9);\n  margin: 0;\n}\n\n.more-filters-category-row:last-child {\n  border-bottom: none;\n}\n\n.more-filters-category-row:hover {\n  background: var(--bg-primary, #fff);\n}\n\n.more-filters-category-row input {\n  margin-top: 3px;\n  flex-shrink: 0;\n  accent-color: var(--accent-primary, #6366f1);\n}\n\n.more-filters-category-title {\n  flex: 1;\n  min-width: 0;\n  line-height: 1.35;\n  word-break: break-word;\n}\n/* Тёмная тема (DEV): текст кнопки/чекбоксов доп.фильтров сливался,\n   белая обводка бейджа — под тёмную поверхность. */\n:root[data-theme='dark'] .more-filters-button {\n  color: var(--text-secondary);\n}\n\n:root[data-theme='dark'] .more-filters-button:hover,\n:root[data-theme='dark'] .more-filters-checkbox-text {\n  color: var(--text-primary);\n}\n\n:root[data-theme='dark'] .more-filters-badge {\n  border-color: var(--bg-card);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
